import Id, {Ids} from './IdFactory';
import { IMAGE_SETS } from './RecordTypes';
const processMap = {
  "cellCulture":{

    /*
     talk about "vessels", "inputs", ... etc.
     but we really should just be putting out the UI and not thinking about the design.
     that way we can just show how they put stuff in...

     and how they publish...


      Okay, now we need to put samples into
      the gel....
      These are going to be lysis outputs
      So there IS some lysate step....
      But, for now, we're just creating conditions...
      We're not putting all the processes in.




      
    */
    inputs:{},
    outputs:{},
    steps:[],
  },
  "loose-treatment":() => ({
    data:{},
    measurements:{},
  }),
  "basic-microscopy":() => ({
    data:{},
    measurements:{
      DEFAULT_MEASUREMENT:{
        config:{ 
          channels:{}
        },
        dataType:"imageSets",
        schema:"underordedList",
        data:[ ] // imageSet { _id:"..." } goes here.
      }
    }

  }),

  "basic-plate":{ 

  }
}


export default function ProcessExecutionFactory(state,creationArgs){
  let { processId, _id, args } = creationArgs;

  let processArgsFactory = processMap[processId];
  if( !processArgsFactory ){
    throw Error("We have no process args factory for '"+processId+"'");
  }

  return {
    _id:_id || Id(),
    ...processArgsFactory()

  }
}
